import React from "react";
import style from "../../../containers/treatmentReport.module.scss";
import { Button, DateTimePicker, Form, MultiSelect, Organizational } from "../../primary";
import { useForm } from "react-hook-form";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useRef } from "react";
import { convertnewDateToDate, getFacilityLabel } from "../../../utils";
import { subDays } from "date-fns";
import {
  getTreatmentOutcomeOverViewData,
  setTreatmentOverViewData,
  setTreatmentReportPayload,
  setTreatmentWorklistData,
} from "../../../app/woundReportSlice";
import { useEffect } from "react";
import { optionTypeAsync } from "../../../app/patientSlice";
import { getTretmentFaciltiestCustomerAsyn } from "../../../app/usageAnalyticsReportSlice";
import useFacilityOptions from "../../../hooks/useFacilityOptions";

export const TreatmentReportForm = ({ setSelectedDivOption }) => {
  const dispatch = useDispatch();
  const { register, handleSubmit, control, errors, reset } = useForm();

  const treatmentReportPayload = useSelector((state) => state.woundreport.treatmentReportPayload);
  const getFacilities = useSelector((state) => state.usageAnalyticsReport.treatmentCustomerFacilities);
  const woundTypeData = useSelector((state) => state.patient.woundType);
  const userDetails = useSelector((state) => state.user);

  const [firstTime, setFirstTime] = useState("");
  const [startDate, setStartDate] = useState(new Date());
  const [toDateRes, setToDateRes] = useState("");
  const [showApplyState, setShowApplyState] = useState(false);
  const [resetFacility, setResetFacility] = useState(false);
  const [selectedFacilities, setSelectedFacilities] = useState([]);
  const [orgError, setOrgError] = useState(false);
  const [onselectOrgz, setOnselectOrgz] = useState([]);
  const [selectedWoundValue, setSelectedWoundValue] = useState(treatmentReportPayload?.woundType ?? []);

  const dateRangeRef1 = useRef(null);
  const dateRangeRef2 = useRef(null);
  const woundTypeRef = useRef(null);

  const facilities = getFacilities?.data?.facilities ?? [];
  const optionData = useFacilityOptions(facilities);

  useEffect(() => {
    dispatch(optionTypeAsync("insurancepayer"));
    dispatch(optionTypeAsync("woundType"));
  }, []);

  useEffect(() => {
    dispatch(setTreatmentWorklistData({}));
    dispatch(setTreatmentOverViewData({}));
    dispatch(
      getTretmentFaciltiestCustomerAsyn(
        treatmentReportPayload.tempTreatmentCustomer ? treatmentReportPayload.tempTreatmentCustomer : userDetails?.customerNumber
      )
    );
    setFirstTime(true);
    setShowApplyState(false);
    let wountCountPayload = {
      ...treatmentReportPayload,
      optionSelected: treatmentReportPayload?.optionSelected ? treatmentReportPayload.optionSelected : "Wound Cleansers",
    };
    dispatch(setTreatmentReportPayload(wountCountPayload));
  }, []);

  const pageOnloadAPI = () => {
    let facilitykey = [];
    optionData &&
      Array.isArray(optionData) &&
      optionData.map((item) => {
        let facility = item.key.split("|")[0].trim();
        facilitykey = [...facilitykey, facility];
      });
    const payload = {
      fromDate: convertnewDateToDate(new Date(document.getElementById("datePicker1").value)),
      toDate: convertnewDateToDate(new Date(document.getElementById("datePicker2").value)),
      facility: facilitykey,
      woundType: "",
      payor: "",
      isDischargedPatient: 0,
    };
    if (optionData.length > 0) {
      if (treatmentReportPayload && treatmentReportPayload?.facility && treatmentReportPayload?.facility.length !== 0) {
        dispatch(getTreatmentOutcomeOverViewData(treatmentReportPayload));
        setTreatmentReportPayload(treatmentReportPayload);
        setShowApplyState(true);
      } else {
        if (payload.facility && payload.facility.length > 0) {
          let treatPayload = {
            ...payload,
            optionSelected: treatmentReportPayload?.optionSelected ? treatmentReportPayload.optionSelected : "Wound Cleansers",
            onselectOrgz: optionData,
          };

          dispatch(getTreatmentOutcomeOverViewData(treatPayload));
          setTreatmentReportPayload(treatPayload);
          dispatch(setTreatmentReportPayload(treatPayload));
        }
      }

      if (document.getElementById("datePicker1").value) {
        setToDateRes(new Date(document.getElementById("datePicker1").value));
      }
    }
  };

  useEffect(() => {
    if (firstTime && getFacilities?.data?.facilities.length > 0 && document.getElementById("datePicker1") && document.getElementById("datePicker2")) {
      setTimeout(() => {
        setFirstTime(false);
        pageOnloadAPI();
      }, 100);
    }
  }, [firstTime, getFacilities]);

  const customFromDatePickerChange = (e) => {
    const fromDates = new Date(e).getTime();
    const toDates = new Date(document.getElementById("datePicker2").value).getTime();
    setToDateRes(new Date(e));
    setTimeout(() => {
      if (fromDates > toDates) {
        document.getElementById("datePicker2").value = "";
      }
    }, 500);
    setShowApplyState(true);
  };
  const handleOnBlurFrom = ({ target: { value } }) => {
    const fromDates = new Date(value).getTime();
    const toDates = new Date(document.getElementById("datePicker2").value).getTime();
    setToDateRes(new Date(value));
    setTimeout(() => {
      if (fromDates > toDates) {
        document.getElementById("datePicker2").value = "";
      }
    }, 500);
  };
  const handleOnBlurTO = ({ target: { value } }) => {
    const fromDates = new Date(document.getElementById("datePicker1").value).getTime();
    const toDates = new Date(value).getTime();
    setTimeout(() => {
      if (fromDates > toDates) {
        document.getElementById("datePicker2").value = "";
        setToDateRes("");
      }
    }, 500);
  };
  const customToDatePickerChange = (e) => {
    setShowApplyState(true);
    const fromDates = new Date(document.getElementById("datePicker1").value).getTime();
    const toDates = new Date(e).getTime();
    setTimeout(() => {
      if (fromDates > toDates) {
        document.getElementById("datePicker1").value = "";
        setToDateRes("");
      }
    }, 500);
  };

  const onSelectOrg = (selectedList) => {
    if (Array.isArray(optionData) && selectedList && Array.isArray(selectedList) && optionData?.length !== selectedList?.length) {
      setShowApplyState(true);
      setResetFacility(false);
    }
    if (setSelectedFacilities) {
      setOrgError(false);
      let facilitykey = [];
      selectedList &&
        Array.isArray(selectedList) &&
        selectedList.map((item) => {
          let facility = item.key.split("|")[0].trim();
          facilitykey = [...facilitykey, facility];
        });
      setSelectedFacilities(facilitykey);
    }
    if (Array.isArray(selectedList) && selectedList.length === 0) {
      setOnselectOrgz([]);
    } else {
      setOnselectOrgz([...selectedList]);
    }
  };

  const handleWoundChange = (e) => {
    setShowApplyState(true);
    const keys = Array.isArray(e) ? e.filter((item) => item.key !== "").map((item) => item.key) : [];
    setSelectedWoundValue(keys);
  };

  const resetData = () => {
    setOnselectOrgz([]);
    // dispatch(setTreatmentCustomerFacilities({}));
    dispatch(setTreatmentReportPayload({}));
    reset({ woundType: "", payorType: "", isDischargedPatient: "" });
    woundTypeRef.current.resetSelectedValues([]);
    setSelectedWoundValue("");
    setShowApplyState(true);
    // setSubmitState(false);
    setResetFacility(true);
    setSelectedDivOption("Wound Cleansers");
    // dispatch(getTretmentFaciltiestCustomerAsyn(userDetails?.customerNumber));
    setTimeout(() => {
      setFirstTime(true);
    }, 500);
  };

  const onSubmit = (data) => {
    // setErrorMsg("");
    if (selectedFacilities.length === 0) {
      setOrgError(true);
    } else {
      setOrgError(false);
    }
    // setSubmitState(true);
    let payload = {
      fromDate: convertnewDateToDate(data.datePicker1),
      toDate: convertnewDateToDate(data.datePicker2),
      facility: selectedFacilities,
      woundType: selectedWoundValue,
      // payor: data.payorType,
      isDischargedPatient: data.isDischargedPatient === "Include Discharged Patients" ? 1 : 0,
    };
    const fromDates = new Date(document.getElementById("datePicker1").value).getTime();
    const toDates = new Date(document.getElementById("datePicker2").value).getTime();
    setToDateRes(new Date(document.getElementById("datePicker1").value));
    setTimeout(() => {
      if (fromDates > toDates) {
        document.getElementById("datePicker2").value = "";
      } else {
        if (selectedFacilities.length > 0) {
          dispatch(getTreatmentOutcomeOverViewData(payload));
          setTreatmentReportPayload({ ...payload, selectedOption: "Wound Cleansers" });
          setSelectedDivOption("Wound Cleansers");
          let tempTreatmentPayload = { ...payload, onselectOrgz: onselectOrgz };
          if (document.getElementById("customerNumber")?.value) {
            tempTreatmentPayload = {
              ...tempTreatmentPayload,
              tempTreatmentCustomer: document.getElementById("customerNumber").value,
            };
          }
          dispatch(setTreatmentReportPayload(tempTreatmentPayload));
        }
      }
    }, 10);
  };

  return (
    <Form className={style.wound_form} onSubmit={handleSubmit(onSubmit)}>
      <div className={`col-8 ${style.col_spec}`}>
        <label className={`col-5 ${style.label_spec}`}>Date Range:</label>
        <DateTimePicker
          id={"datePicker1"}
          name={"datePicker1"}
          control={control}
          classes={{
            date_picker: style.wound_input,
            dateColumn: "col-12 p-0",
            column: `col m-0 ${style.col_spec}`,
          }}
          customOnChange={customFromDatePickerChange}
          defaultValue={
            treatmentReportPayload && treatmentReportPayload.fromDate ? new Date(treatmentReportPayload.fromDate) : subDays(new Date(startDate), 30)
          }
          displayIcon={true}
          validator={register()}
          showMonthDropdown={true}
          showYearDropdown={true}
          dateRef={dateRangeRef1}
          errors={errors}
          maxDate={new Date()}
          onBlur={handleOnBlurFrom}
        />
        <DateTimePicker
          id={"datePicker2"}
          name={"datePicker2"}
          control={control}
          classes={{
            date_picker: style.wound_input,
            dateColumn: "col-12 p-0",
            column: `col m-0 pr-0 ${style.col_spec}`,
          }}
          defaultValue={treatmentReportPayload && treatmentReportPayload.toDate ? new Date(treatmentReportPayload.toDate) : new Date()}
          customOnChange={customToDatePickerChange}
          displayIcon={true}
          validator={register()}
          showMonthDropdown={true}
          showYearDropdown={true}
          dateRef={dateRangeRef2}
          minDate={toDateRes ? toDateRes : ""}
          errors={errors}
          maxDate={new Date()}
          onBlur={handleOnBlurTO}
        />
      </div>
      <div className={`col-4 ${style.col_spec}`}></div>

      {optionData && Array.isArray(optionData) && optionData.length === 0 && (
        <Organizational
          id={"facility"}
          name={"facility"}
          label={`Facility/Location:`}
          classes={{
            column: `col-8 ${style.col_spec}`,
            inputClassName: style.wound_select,
            labelClassName: `col-5 ${style.label_spec}`,
            inputColumn: `col-7 p-0`,
          }}
          optionValue={Array.isArray(optionData) ? optionData : []}
          groupBy="cat"
          displayValue="key"
          onSelect={onSelectOrg}
          selectAll={true}
          resetDefault={resetFacility}
          reportView={true}
          customError={orgError}
          required={true}
          defaultValue={Array.isArray(onselectOrgz) && onselectOrgz.length > 0 ? onselectOrgz : optionData}
        />
      )}

      {optionData && Array.isArray(optionData) && optionData.length !== 0 && (
        <Organizational
          id={"facility"}
          name={"facility"}
          label={`Facility/Location:`}
          classes={{
            column: `col-8 ${style.col_spec}`,
            inputClassName: style.wound_select,
            labelClassName: `col-5 ${style.label_spec}`,
            inputColumn: `col-7 p-0`,
          }}
          optionValue={optionData}
          groupBy="cat"
          displayValue="key"
          defaultValue={
            Array.isArray(treatmentReportPayload?.onselectOrgz) && treatmentReportPayload.onselectOrgz.length > 0
              ? treatmentReportPayload.onselectOrgz
              : Array.isArray(onselectOrgz) && onselectOrgz.length > 0
              ? onselectOrgz
              : optionData
          }
          onSelect={onSelectOrg}
          selectAll={true}
          resetDefault={resetFacility}
          reportView={true}
          customError={orgError}
          required={true}
        />
      )}

      <div className={`col-4 ${style.col_spec}`}></div>

      <MultiSelect
        id={"woundType"}
        name={"woundType"}
        label={"Wound Types:"}
        classes={{
          column: `col-8 ${style.col_spec}`,
          inputClassName: style.wound_select,
          labelClassName: `col-5 ${style.label_spec}`,
          inputColumn: `col-7 p-0 ${style.select_wrapper}`,
        }}
        optionValue={woundTypeData}
        validator={(e) => {
          register({ required: true });
          woundTypeRef.current = e;
        }}
        placeholder="Select"
        showCheckbox={true}
        displayValue="value"
        onSelect={handleWoundChange}
        onRemove={handleWoundChange}
        labelSubText={"Select all that apply"}
        defaultValue={treatmentReportPayload && treatmentReportPayload.woundType ? treatmentReportPayload.woundType : []}
      />
      <div className={`col-4 ${style.col_spec}`}></div>
      {showApplyState && (
        <div className={`col-8 ${style.col_spec}`}>
          <label className={`col-5 ${style.label_spec}`}></label>
          <Button
            classes={{
              className: `btn ${style.btn_custom} ${style.btn_small} mr-4`,
            }}
            type="submit"
          >
            Apply
          </Button>
          <Button
            classes={{
              className: `btn ${style.btn_custom} ${style.btn_small_cancel} `,
            }}
            onClick={resetData}
            type={"button"}
          >
            Reset
          </Button>
        </div>
      )}
    </Form>
  );
};
